export type KnowledgeHubConfig = {
  logoEnabled?: boolean;
  logoImageUrl?: string;
  faviconEnabled?: boolean;
  faviconUrl?: string;
  coverPhoto: {
    light: {
      enabled: boolean;
      imageUrl?: string;
      type: "quack" | "custom";
    };
    dark: {
      enabled: boolean;
      imageUrl?: string;
      type: "quack" | "custom";
    };
  };
  inputPlaceholder?: string;
  pageTitle?: string;
  greetingTitle?: string;
  font?: {
    family: string;
    url: string;
  };
  auth?: {
    enabled: boolean;
    oidcClientId?: string;
    oidcAuthority?: string;
    oidcAudience?: string;
    supportTickets?: {
      enabled: boolean;
      allowUserReplyToTicket?: boolean;
      statusesToCountAsOpen?: string[];
      statusesToDisplayOnThePage?: string[];
      endUserTicketName?: string;
    };
  };
  theme: {
    mode: "light" | "dark" | "system";
    dark: {
      background: string;
      foreground: string;
      primary: string;
      primaryForeground: string;
      secondary: string;
      secondaryForeground: string;
      accent: string;
      accentForeground: string;
    };
    light: {
      background: string;
      foreground: string;
      primary: string;
      primaryForeground: string;
      secondary: string;
      secondaryForeground: string;
      accent: string;
      accentForeground: string;
    };
  };
};

export const defaultKnowledgeHubConfig: KnowledgeHubConfig = {
  logoEnabled: true,
  logoImageUrl: "",
  faviconEnabled: true,
  faviconUrl: "",
  coverPhoto: {
    light: {
      enabled: true,
      type: "quack",
      imageUrl:
        "https://d1yrspa5kjocbp.cloudfront.net/quack-default/cover/cover1.jpeg",
    },
    dark: {
      enabled: true,
      type: "quack",
      imageUrl:
        "https://d1yrspa5kjocbp.cloudfront.net/quack-default/cover/cover1.jpeg",
    },
  },
  inputPlaceholder: "Ask me anything...",
  greetingTitle: "Hello, how can I help you today?",
  font: {
    family: "Inter",
    url: "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap",
  },
  theme: {
    mode: "system",
    dark: {
      background: "#020817",
      foreground: "#F8FAFC",
      primary: "#F8FAFC",
      primaryForeground: "#F8FAFC",
      secondary: "#1E293B",
      secondaryForeground: "#F8FAFC",
      accent: "#F8FAFC",
      accentForeground: "#F8FAFC",
    },
    light: {
      background: "#FFFFFF",
      foreground: "#020817",
      primary: "#020817",
      primaryForeground: "#F8FAFC",
      secondary: "#F1F5F9",
      secondaryForeground: "#F8FAFC",
      accent: "#F8FAFC",
      accentForeground: "#F8FAFC",
    },
  },
};

export const GOOGLE_FONTS = [
  {
    label: "Inter",
    value: "Inter",
    url: "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap",
  },
  {
    label: "Roboto",
    value: "Roboto",
    url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
  },
  {
    label: "Open Sans",
    value: "Open Sans",
    url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap",
  },
  {
    label: "Lato",
    value: "Lato",
    url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
  },
  {
    label: "Montserrat",
    value: "Montserrat",
    url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap",
  },
  {
    label: "Poppins",
    value: "Poppins",
    url: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
  },
  {
    label: "Merriweather",
    value: "Merriweather",
    url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
  },
  {
    label: "Playfair Display",
    value: "Playfair Display",
    url: "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap",
  },
  {
    label: "Rubik",
    value: "Rubik",
    url: "https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap",
  },
  {
    label: "Work Sans",
    value: "Work Sans",
    url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap",
  },
];

export const COLOR_FIELDS = [
  { key: "background", label: "Background" },
  { key: "foreground", label: "Foreground" },
  { key: "primary", label: "Primary" },
  { key: "primaryForeground", label: "Primary Foreground" },
  { key: "secondary", label: "Secondary" },
  { key: "secondaryForeground", label: "Secondary Foreground" },
  { key: "accent", label: "Accent" },
  { key: "accentForeground", label: "Accent Foreground" },
];

export const CONTRAST_PAIRS: Record<string, string> = {
  foreground: "background",
  primaryForeground: "primary",
  secondaryForeground: "secondary",
  accentForeground: "accent",
};
